import { MouseEvent } from 'react'
import { Link } from '../at-navbar-link'
import { textColorTransition } from '../at-tabs/shared/classes'

export interface AtAnchorLinksProps {
  links: Omit<Link, 'target'>[]
  onClick: (key: string) => void
  visibleKey: string
  // Fix for BDP, it uses different content blocks from the Visitors' Guide, **these two files should be considered for merging into one**, this is a fix to consider the secondary navbar height and scroll just before that on a given section
  accountForNavbar?: boolean
}

export const AtAnchorLinks = ({ links = [], accountForNavbar = false, onClick, visibleKey }: AtAnchorLinksProps) => {
  const scrollToSection = (e: MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()

    if (href !== '#') {
      const section = document.getElementById(href.replace('#', ''))

      if (section) {
        if (accountForNavbar) {
          const secondaryNavigation = document.getElementById('secondary-navigation') as HTMLDivElement
          const navbarHeight = secondaryNavigation.getBoundingClientRect()
          window.scrollTo({ behavior: 'smooth', top: section.offsetTop - navbarHeight.height })
        } else section.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }

  return (
    <nav className="flex flex-row justify-between grow py-2">
      {links.slice(0, 7).map((link, index) => (
        <div key={index} className="group">
          <a
            href={link.href}
            onClick={(e) => {
              scrollToSection(e, link.href)
              onClick(link.href.replace('#', ''))
              if (link.onTrackClick) {
                link.onTrackClick(e)
              }
            }}
            className={`${textColorTransition} group relative focus:outline-none focus-visible:outline focus-visible:outline-1 focus-visible:outline-offset-4 focus-visible:outline-neutrals-900 inline-flex shrink-0 h-12 items-center justify-center ${
              link.href.replace('#', '') === visibleKey
                ? 'text-secondary-700'
                : 'text-neutrals-700 hover:text-neutrals-800 focus:text-neutrals-800'
            }`}
          >
            {link.label}
            <div
              className={`absolute bottom-[0] h-0.5 transition-[width] ease-custom duration-500 group-hover:w-full group-focus:w-full ${
                link.href.replace('#', '') === visibleKey
                  ? 'w-full bg-secondary-700'
                  : 'w-[0] group-hover:bg-neutrals-800 '
              }`}
            />
          </a>
        </div>
      ))}
    </nav>
  )
}
